<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-files"></i>
              客户文件管理
            </h1>
            <p class="page-subtitle">管理客户上传的订单文件，支持查看文件详情和下载</p>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="文件名称">
              <el-input 
                v-model="searchCondition.file_name" 
                placeholder="输入订单文件名称" 
                clearable
                prefix-icon="el-icon-document">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-tooltip effect="dark" content="返回客户列表" placement="top">
                <el-button 
                  type="info" 
                  size="medium" 
                  icon="el-icon-back" 
                  @click="back"
                  class="back-btn">
                  返回
                </el-button>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
        <ApeTable ref="apeTable" :data="list" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
          <el-table-column
              width="80"
            label="序号">
            <template slot-scope="scope">
                <span class="row-number">{{offset+scope.$index+1}}</span>
            </template>
          </el-table-column>
           <el-table-column
              label="文件信息">
            <template slot-scope="scope">
                <div class="file-info">
                  <p class="file-name">
                    <i class="el-icon-document"></i>
                    <strong>{{scope.row.file_name}}</strong>
                  </p>
                  <p><strong>存储路径：</strong>{{scope.row.file_path}}</p>
                  <p><strong>访问地址：</strong>
                    <el-link :href="publicAssetUrl(scope.row.file_path)" target="_blank" type="primary">{{ publicAssetUrl(scope.row.file_path) }}</el-link>
                  </p>
                  <p><strong>格式：</strong><el-tag size="mini" type="info">{{scope.row.file_format}}</el-tag></p>
                </div>
            </template>
          </el-table-column>
          <el-table-column
              label="文件尺寸">
            <template slot-scope="scope">
                <div class="dimension-info">
                  <p><strong>体积：</strong>{{scope.row.file_volume}}</p>
                  <p><strong>高度：</strong>{{scope.row.file_high}}</p>
                  <p><strong>长度：</strong>{{scope.row.file_length}}</p>
                  <p><strong>宽度：</strong>{{scope.row.file_width}}</p>
                </div>
            </template>
          </el-table-column>
          <el-table-column
              label="文件属性">
            <template slot-scope="scope">
                <div class="property-info">
                  <p><strong>表面积：</strong>{{scope.row.file_volumearea}}</p>
                  <p><strong>文件大小：</strong><el-tag size="small" type="success">{{scope.row.file_size}}</el-tag></p>
                  <p><strong>上传时间：</strong>{{scope.row.upload_at}}</p>
                </div>
            </template>
          </el-table-column>  
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        file_name:'',
        query: "customer_id=?",
        params: [],
      },
      loadingStaus: true,
      uploadFileList:[],
      // 表格列表数据
      list:[],
      // 分页信息
      pagingData:{
        is_show: true,
        current_page: 1,
        page_size: 20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        avatar:''
      },
      // 表单验证
      rules: {
        department_name: [{required: true,message:'选择语言版本', trigger: 'blur' }],
        department_desc: [{required: true,message:'输入订单文件名称', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    publicAssetUrl(path) {
      if (path == null || path === '') return ''
      const s = String(path).replace(/\\/g, '/')
      if (/^https?:\/\//i.test(s)) return s
      if (s.startsWith('/assets/')) return s
      const marker = '/assetslib/'
      const i = s.indexOf(marker)
      if (i !== -1) {
        return '/assets/' + s.slice(i + marker.length).replace(/^\/+/, '')
      }
      return s
    },
    // 搜索
    setSearchCondition() {
      this.searchCondition.query= ''
      this.searchCondition.params = []
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition,pagingInfo)
      this.searchCondition.params=[this.$route.params.id]
      this.searchCondition.query = 'customer_id=?'
      if (this.searchCondition.file_name != ''){
        this.searchCondition.query =this.searchCondition.query +  ' and instr(file_name,?)'
        this.searchCondition.params.push(this.searchCondition.file_name)
      }
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    back(){
      this.$router.push('/customer/list/')
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加订单文件'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.uploadFileList=[]
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑用户(UID：'+id+')'
      let {info} = await this.$api.getCustomerOrderFile(id)
      this.formData = info
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id 
      if (this.formData.id==null || this.formData.id==0){
          id = await this.$api.addCustomerOrderFile(this.formData)
      }else{
          id = await this.$api.modifyCustomerOrderFile(this.formData)
      }
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id = await this.$api.addCustomerOrderFile(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteCustomerOrderFile(id)
      if (info==null) {
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_role:{system_role_id:0}}
        this.$refs['userForm'].resetFields()
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.staff_image = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.staff_image = 0
      this.uploadFileList = fileList
    },
    async getList() {
      this.loadingStaus=true
      this.setSearchCondition()
      let res= await this.$api.post('/service/ola_app_customer_file/list',this.searchCondition)
      if (this.$apiSuccess(res)){
          this.list = res.data.list
          this.pagingData.total = res.data.page.total
      }else{
        this.$message.error(res.message)
        return
      }
      this.loadingStaus=false
    }
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 12px 24px
    font-weight 500
    margin-right 12px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  .back-btn
    background linear-gradient(45deg, #9ca3af, #6b7280)
    border none
    border-radius 8px
    padding 12px 20px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(156, 163, 175, 0.3)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  // 序号样式
  .row-number
    font-weight 600
    color #667eea
    background #f0f4ff
    padding 4px 8px
    border-radius 4px
    font-size 12px

  // 文件信息
  .file-info
    .file-name
      margin 4px 0
      display flex
      align-items center
      gap 8px
      
      i
        color #667eea
        font-size 16px
      
      strong
        color #1f2937
        font-size 14px
    
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      
      strong
        color #374151
        font-weight 600

  // 尺寸信息
  .dimension-info
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      
      strong
        color #374151
        font-weight 600

  // 属性信息
  .property-info
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      
      strong
        color #374151
        font-weight 600

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .search-card, .table-card
      padding 16px
      
    .file-info, .dimension-info, .property-info
      p, .file-name
        font-size 12px
</style>
